export const formatTime = (timeMs: number, penalty?: '+2' | 'DNF'): string => {
  if (penalty === 'DNF') return 'DNF';
  
  const totalMs = timeMs + (penalty === '+2' ? 2000 : 0);
  const minutes = Math.floor(totalMs / 60000);
  const seconds = Math.floor((totalMs % 60000) / 1000);
  const milliseconds = totalMs % 1000;

  let time = '';
  if (minutes > 0) {
    time = `${minutes}:${seconds.toString().padStart(2, '0')}.${milliseconds.toString().padStart(3, '0')}`;
  } else {
    time = `${seconds}.${milliseconds.toString().padStart(3, '0')}`;
  }
  
  return penalty === '+2' ? `${time}+` : time;
}; 